<template>
  <div class>
    <!-- header start -->
    <van-nav-bar
      title="视频上传"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <div>
      <div class="video-uploader">
        <van-uploader :after-read="afterRead" accept="video/*">
          <div class="video-btn">
            <i class="fa fa-video-camera"></i>
            <span class="t15 c6 martop10">上传视频</span>
          </div>
        </van-uploader>
      </div>
      <van-field v-model="videoName" readonly placeholder="选择后显示视频文件名" />

      <van-field v-model="input.Title" placeholder="视频名称" />
      <van-field
        v-model="input.Description"
        rows="5"
        autosize
        type="textarea"
        maxlength="150"
        placeholder="视频描述"
      />
      <div class="btn-area">
        <van-button @click="onSubmit" round block class="mybtn" native-type="submit">确定</van-button>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
export default {
  data() {
    return {
      // title: "",
      // message: "",
      videoName: "",
      input: {
        Id: "",
        Title: "",
        Description: "",
        Base64Content: ""
      }
    };
  },
  mounted() {
    var that = this;
    console.log(that.$route.query);
    that.input.Id = that.$route.query.id;

  },
  components: {},
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    afterRead(file) {
      console.log(file);
      this.videoName = file.file.name;
      this.input.Base64Content = file.content;
    },
    onSubmit() {
      var that=this;
      var postData=that.input;
      if(postData.Title==""){
          Toast("视频名字不能为空！");
          return false;
      }
      Object.assign(postData,{
          type:"VideoAddVue"
      });
      that.$store.dispatch(postData).then(res=>{
          Toast(res.Message);
          if(res.IsSuccess)
          {
              this.$router.go(-1);
          }

      },error=>{

      });
      

    }
  }
};
</script>

<style scoped>
.video-uploader {
  padding: 20px;
  background-color: #f2f2f2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.video-btn {
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-size: 48px;
  color: #777;
}
</style>
